import {
  COWS_FETCH_REQUEST,
  COWS_FETCH_SUCCESS,
  COWS_FETCH_FAIL,
  COWS_SET_SORT,
  COWS_SELECT_COW,
  COWS_VIDEO_PLAY_STOP,
  COWS_SET_PAGE,
  COWS_SET_PAGE_SIZE
} from './constants';

export const fetchCows = () => ({
  type: COWS_FETCH_REQUEST
});
export const fetchCowsSuccess = (cows, scoreDefinitions) => ({
  type: COWS_FETCH_SUCCESS, cows, scoreDefinitions
});
export const fetchCowsFail = (error) => ({
  type: COWS_FETCH_FAIL, error
});
export const setCowSort = (sortAttribute) => ({
  type: COWS_SET_SORT, sortAttribute
});
export const setSelectedCow = id => ({
  type: COWS_SELECT_COW, id
});
export const setVideoPlaying = (playing = true) => ({
  type: COWS_VIDEO_PLAY_STOP, playing
});
export const setCowsPage = page => ({
  type: COWS_SET_PAGE, page
});
export const setCowsPageSize = pageSize => ({
  type: COWS_SET_PAGE_SIZE, pageSize
});
